export const MOCK_QUIZ_ME_DATA = [{
  questionTitle: 'Question 1 Question 1 Question 1 Question 1 Question 1 Question 1 Question 1 Question 1 Question 1 ',
  questionText: 'Question 1 text',
  answers: [{
    answerOptionText: 'Answer 1',
    correct: false,
    responseTitle: 'Answer 1 title',
    responseText: 'Answer 1 text Answer 1 text Answer 1 text Answer 1 text Answer 1 text Answer 1 text Answer 1 text Answer 1 text'
  }, {
    answerOptionText: 'Answer 2',
    correct: false,
    responseTitle: 'Answer 2 title',
    responseText: 'Answer 2 text Answer 2 text Answer 2 text Answer 2 text Answer 2 text Answer 2 text Answer 2 text Answer 2 text'
  }, {
    answerOptionText: 'Answer 3',
    correct: true,
    responseTitle: 'Answer 3 title',
    responseText: 'Answer 3 text Answer 3 text Answer 3 text Answer 3 text Answer 3 text Answer 3 text Answer 3 text Answer 3 text'
  }, {
    answerOptionText: 'Answer 4',
    correct: false,
    responseTitle: 'Answer 4 title',
    responseText: 'Answer 4 text Answer 4 text Answer 4 text Answer 4 text Answer 4 text Answer 4 text Answer 4 text Answer 4 text'
  }]
}, {
  questionTitle: 'Question 2 Question 2 Question 2 Question 2 Question 2 Question 2 Question 2 Question 2 Question 2',
  questionText: 'Question 2 text',
  answers: [{
    answerOptionText: 'Answer 4',
    correct: false,
    responseTitle: 'Answer 4 title',
    responseText: 'Answer 4 text Answer 4 text Answer 4 text Answer 4 text Answer 4 text Answer 4 text Answer 4 text Answer 4 text'
  }, {
    answerOptionText: 'Answer 5',
    correct: false,
    responseTitle: 'Answer 5 title',
    responseText: 'Answer 5 text Answer 5 text Answer 5 text Answer 5 text Answer 5 text Answer 5 text Answer 5 text Answer 5 text'
  }, {
    answerOptionText: 'Answer 6',
    correct: true,
    responseTitle: 'Answer 6 title',
    responseText: 'Answer 6 text Answer 6 text Answer 6 text Answer 6 text Answer 6 text Answer 6 text Answer 6 text Answer 6 text'
  }, {
    answerOptionText: 'Answer 7',
    correct: false,
    responseTitle: 'Answer 7 title',
    responseText: 'Answer 7 text Answer 7 text Answer 7 text Answer 7 text Answer 7 text Answer 7 text Answer 7 text Answer 7 text'
  }]
}];